import script from "./registerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./registerPage.vue?vue&type=script&setup=true&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=42f8c940&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f8c940"]])

export default __exports__